import Grid from '@material-ui/core/Grid';
import React, { FunctionComponent } from 'react';
import pure from 'recompose/pure';
import { OptionId } from '../../../../../../models/itinerary';
import { ProviderDetailsContainer } from './ProviderDetails/ProviderDetailsContainer';
import { ProviderLogos } from './ProviderLogo/ProviderLogos';

interface OwnProps {
  segmentId: number;
  optionId: OptionId;
}

interface ProviderColumnProps extends OwnProps {}

const ProviderColumnBase: FunctionComponent<ProviderColumnProps> = ({
  segmentId,
  optionId,
}) => (
  <Grid item container wrap="nowrap" alignItems="center" spacing={16}>
    <Grid item md={3} sm={1} xs={2}>
      <ProviderLogos segmentId={segmentId} optionId={optionId} />
    </Grid>
    <Grid item zeroMinWidth md={9} sm={11} xs={10}>
      <ProviderDetailsContainer segmentId={segmentId} optionId={optionId} />
    </Grid>
  </Grid>
);

export const ProviderColumn = pure(ProviderColumnBase);

ProviderColumn.displayName = 'ProviderColumn';
